module.exports = __webpack_public_path__ + "img/logo.ed3d9e8f.svg";